'use client';
import NotFoundIcon from '@/components/icons/NotFoundIcon';
import NextLink from '@/components/next-link';
import { useLocale } from 'next-intl';
import ErrorEvent from '@/utils/error-event';

export default function ErrorPage({ error, reset }) {
  console.log('error props', error);
  const locale = useLocale();

  return (
    <div className='flex min-h-screen flex-col items-center justify-center gap-8 max-md:gap-4'>
      <ErrorEvent
        error_message={error?.message || 'Something went wrong'}
        error_type='UI Error'
      />
      <NotFoundIcon className='size-[190px] md:size-[350px]' />
      <h2 className='text-3xl font-semibold max-md:text-base'>
        {locale == 'en' ? 'Something went wrong!' : 'حدث خطأ ما!'}
      </h2>
      <div className='flex gap-4' dir={locale === 'en' ? 'ltr' : 'rtl'}>
        <button
          aria-label='Error Button'
          onClick={reset}
          className='bg-primary hover:bg-primary-900 w-60 cursor-pointer rounded-md p-2 text-center font-bold text-white uppercase max-md:text-xs'
        >
          {locale == 'en' ? 'Try again' : 'حاول مره أخرى'}
        </button>
        <NextLink
          href={'/'}
          className={`hover:bg-primary text-primary border-primary w-60 rounded-md border bg-white p-2 text-center font-bold uppercase transition-all hover:text-white max-md:text-sm max-sm:text-xs`}
        >
          {locale === 'en' ? 'Back to Home' : 'العودة إلى الرئيسية'}
        </NextLink>
      </div>
    </div>
  );
}
